import { memo } from 'react';

import CircleUpRightIconSVG from '@/assets/circle-up-right.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICircleUpRightIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={CircleUpRightIconSVG} {...props} />
);

export const CircleUpRightIcon = memo(ICircleUpRightIcon) as typeof ICircleUpRightIcon;
